import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import styled from 'styled-components';
import { IconNames } from '@blueprintjs/icons';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Message from 'rc-message';
import { Icon, Intent } from '@blueprintjs/core';
import PageLockHOC from 'hoc/pageLock';
import Permissions from 'react-redux-permissions';

import Clearfix from 'components/elements/clearfix';
import DisplayField from 'components/elements/display-field';
// import InnerHTML from 'components/elements/InnerHTML';
import slug from 'constants/slug';
import AttachmentContainer from 'containers/AttachmentContainer';
import { getOne, getAuditDetail, deleteOne } from 'api/facilityAuditApi';
import {
  getList as getAttachList,
  deleteOne as deleteAttach,
  create as createAttach,
} from 'api/facilityAudiAttachmentApi';
import { getLookupTypeAuditAttachment } from 'api/lookuplistitemApi';
import Confirm from 'components/elements/confirm-element';
import { DATE_FORMAT, DATETIME_FORMAT } from 'config';
import { COLOR } from 'config';

const ContainerWrapper = styled.div``;
const ContainerHeader = styled.div`
  display: flex;
`;
const ContainerAction = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
const Content = styled.div``;

const NameContainer = styled.div`
  color: ${COLOR.SECOND_COLOR};
  text-decoration: underline;
`;

@PageLockHOC(['facilityAudit.view'])
export default class InspectionView extends React.Component {
  static propTypes = {};

  state = {
    _idObject: '',
    isLoading: true,
    initialValue: {},
    initialDetail: [],
  };
  columnDetails = [
    {
      dataField: 'Facility',
      text: 'Tên cơ sở/dự án',
      formatter: (cell, row) => {
        return (
          <Link
            to={`${slug.AUDIT.VIEW_WITH_ID_CHILD}${row._id}/${this.getId()}`}
          >
            <NameContainer>{cell && cell.FacilityNameFull}</NameContainer>
          </Link>
        );
      },
    },
    {
      dataField: 'status.Name',
      text: 'Trạng thái cập nhật',
    },
    {
      dataField: 'AddedOn',
      text: 'Thêm vào',
      formatter: (cell, row) => {
        return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
      },
    },
    {
      dataField: 'UpdatedOn',
      text: 'Cập nhật vào',
      formatter: (cell, row) => {
        return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
      },
    },
  ];

  getId() {
    const _id = _.result(this.props, 'match.params._id');
    return _id;
  }

  async checkValidate() {
    const _id = this.getId();
    if (_id) {
      const res = await getOne(_id);
      if (res.success) {
        this.setState({
          _idObject: _id,
          isLoading: false,
          initialValue: res.data,
        });
      }
    } else {
      this.props.history.push(slug.AUDIT.LIST);
    }
  }

  async getAuditDetail() {
    const _id = this.getId();
    if (_id) {
      const res = await getAuditDetail(_id);
      if (res.success) {
        this.setState({
          initialDetail: _.get(res, 'data', []),
        });
      }
    } else {
      this.props.history.push(slug.AUDIT.LIST);
    }
  }

  updateInitialValue = (values) => {
    this.setState({
      _idObject: values._id,
      isLoading: false,
      initialValue: values,
    });
  };

  componentWillMount = async () => {
    await Promise.all([this.checkValidate(), this.getAuditDetail()]);
  };

  getInitialValue = (keyPath, defaultValue = '', type = 'string') => {
    const value = _.result(this.state.initialValue, keyPath, defaultValue);
    if (!value || value === '') {
      return '';
    }
    switch (type) {
      case 'date':
      case 'date_1':
        return moment(value).format(
          type === 'date_1' ? DATETIME_FORMAT : DATE_FORMAT
        );
      case 'dates':
        return `${moment(value[0]).format(DATE_FORMAT)} - ${moment(
          value[1]
        ).format(DATE_FORMAT)}`;
      default:
        return value;
    }
  };

  handelDelete = () => {
    if (this.ConfirmElm && this.ConfirmElm.showConfirm) {
      const AuditNumber = this.getInitialValue('AuditNumber');
      this.ConfirmElm.showConfirm({
        content: (
          <div>
            {`Bạn có muốn xóa số quyết định đoàn kiểm tra: `}{' '}
            <b>{AuditNumber}</b>
          </div>
        ),
        cb: async (value) => {
          if (value) {
            const res = await deleteOne(this.getInitialValue('_id'));
            if (res.success) {
              Message.success({ content: 'Thành Công' });
              this.props.history.push(slug.AUDIT.LIST);
            }
            if (res.error) Message.error({ content: res.message });
          }
        },
      });
    }
  };

  render() {
    return (
      <ContainerWrapper>
        <Confirm ref={(ConfirmElm) => (this.ConfirmElm = ConfirmElm)} />
        {!this.state.isLoading && (
          <div>
            <ContainerHeader>
              <h3
                style={{
                  color: COLOR.SUCCESS,
                }}
                className='bp3-heading'
              >
                Chi tiết kiểm tra
              </h3>
            </ContainerHeader>
            <ContainerAction>
              <div style={{ display: 'inline-flex' }}>
                <Icon
                  onClick={() => {
                    this.props.history.push(slug.AUDIT.LIST);
                  }}
                  style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                  icon={IconNames.CIRCLE_ARROW_LEFT}
                  iconSize={Icon.SIZE_LARGE}
                  intent={Intent.SUCCESS}
                />

                <Permissions allowed={[`facilityAudit.write`]}>
                  <React.Fragment>
                    <Clearfix width={8} />
                    <Link
                      to={slug.AUDIT.EDIT_WITH_ID + this.getInitialValue('_id')}
                    >
                      <Icon
                        style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                        icon={IconNames.MANUALLY_ENTERED_DATA}
                        iconSize={Icon.SIZE_LARGE}
                        intent={Intent.PRIMARY}
                      />
                    </Link>
                  </React.Fragment>
                </Permissions>

                <Permissions allowed={[`facilityAudit.delete`]}>
                  <React.Fragment>
                    <Clearfix width={8} />
                    <Icon
                      style={{ cursor: 'pointer' }}
                      icon={IconNames.BAN_CIRCLE}
                      iconSize={Icon.SIZE_LARGE}
                      intent={Intent.DANGER}
                      onClick={this.handelDelete}
                    />
                  </React.Fragment>
                </Permissions>
              </div>
            </ContainerAction>
            <Clearfix height={12} />
            <Content>
              <Clearfix height={12} />
              <DisplayField
                size={14}
                isRequiredField={true}
                label='Số quyết định đoàn kiểm tra'
                value={this.getInitialValue('AuditNumber')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                isRequiredField={true}
                label='Thời gian kiểm tra'
                value={this.getInitialValue('AuditDate', '', 'dates')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Ngày ra quyết định'
                value={this.getInitialValue('DecideDate', '', 'date')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Cơ quan ban hành'
                value={this.getInitialValue('AgencyIssued')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Ghi chú kế hoạch kiểm tra'
                value={this.getInitialValue('Notes')}
              />
              <Clearfix height={16} />
              <DisplayField
                label='Thêm vào'
                value={
                  this.getInitialValue('AddedOn', '', 'date_1') +
                  ' bởi ' +
                  this.getInitialValue('AddedBy')
                }
              />
              <Clearfix height={16} />
              <DisplayField
                label='Cập nhật lần cuối'
                value={`${this.getInitialValue('UpdatedOn', '', 'date_1')}${this.getInitialValue('UpdatedBy', '')
                  ? ` bởi ${this.getInitialValue('UpdatedBy', '')}`
                  : ''
                  }`}
              />
              <Clearfix height={32} />
              <div>
                <BootstrapTable
                  keyField='_id'
                  data={_.sortBy(this.state.initialDetail, ['Facility.FacilityNameFull'])}
                  columns={this.columnDetails}
                  striped
                  hover
                  remote
                />
              </div>
              <Clearfix height={32} />
              <AttachmentContainer
                // hideButtonAction={this.state.isEdit ? false : true}
                facility={this.state.initialValue}
                getListFunc={(query) => {
                  return getAttachList({
                    ...query,
                    audit: this.getInitialValue('_id'), //_id của inspection
                  });
                }}
                createOne={(values) => {
                  values.audit = this.getInitialValue('_id');
                  return createAttach(_.pickBy(values, _.identity));
                }}
                deleteOne={deleteAttach}
                getAttachmentTypeList={getLookupTypeAuditAttachment}
                moduleName='facilityAudit'
              />
            </Content>
          </div>
        )}
      </ContainerWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/FacilityAudit/AuditView/index.js